import React from 'react';
import { Snackbar } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import {
  withServiceWorkerUpdater,
  LocalStoragePersistenceService,
} from 'components/ServiceWorker';
import cn from 'classnames';
import COLORS from 'utils/constants/colors';
// import ButtonIcon from './components/IconButton';
import { RefreshIcon } from 'Icons';
import IconWithText from 'components/IconWithText/iconWithText';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

const useStyles = makeStyles(() => ({
  root: {
    '& .MuiPaper-root': {
      fontWeight: '400',
    },
  },
  snackbar: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '1rem',
    fontSize: '15px',
    width: '300px',
    color: 'white',
    backgroundColor: '#43a047',
    borderRadius: '5px',
    '& > div': {
      flex: '0 0 300',
      color: 'white',
    },
    paddingRight: '20px',
  },
  button: {
    marginLeft: '5px',
  },
  cross: { height: 'auto', position: 'absolute', top: '0', right: '0' },
  warning: {
    backgroundColor: COLORS.WARNING,
  },
}));
const ServiceWorkerWrapper = props => {
  const classes = useStyles();
  const { newServiceWorkerDetected, onLoadNewServiceWorkerAccept } = props;
  const { t } = useTranslation();
  const onClickSnackbar = () => {
    onLoadNewServiceWorkerAccept();
  };

  return (
    <>
      <Snackbar
        open={newServiceWorkerDetected}
        className={classes.root}
        data-test-id="screens-new-version-snackbar"
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <div className={cn(classes.snackbar, classes.warning)}>
          <div> {t('A new version is available')}</div>
          <IconWithText
            title={'Reload'}
            component={RefreshIcon}
            onClick={onClickSnackbar}
            theme={'light'}
          />
        </div>
      </Snackbar>
    </>
  );
};

ServiceWorkerWrapper.propTypes = {
  newServiceWorkerDetected: PropTypes.bool,
  onLoadNewServiceWorkerAccept: PropTypes.func,
};
export default withServiceWorkerUpdater(ServiceWorkerWrapper, {
  log: () => console.warn('App updated!'),
  persistenceService: new LocalStoragePersistenceService('portal'), // This will store the newServiceWorkerDetected variable incase the screen is refreshed or closed
  // Next time when the user opens it, they should see the snackbar again
});
